////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <div>
    <span class="login-form-title">{{i18n.login.signup}}</span>
    <Form ref="loginData" :model="loginData" :rules="loginDataRules">
        <Form-item prop="email">
            <Input type="text" v-model="loginData.email" :placeholder="i18n.login.email" icon="ios-email" size="large" class="input-left-icon"></Input>
        </Form-item>
        <Form-item prop="user">
            <Input type="text" v-model="loginData.user" :placeholder="i18n.login.user" icon="android-contact" size="large" class="input-left-icon"></Input>
        </Form-item>
        <Form-item prop="password">
            <Input type="password" v-model="loginData.password" :placeholder="i18n.login.password" icon="locked" size="large" class="input-left-icon"></Input>
        </Form-item>
        <Form-item prop="passwordTwice">
            <Input type="password" v-model="loginData.passwordTwice" :placeholder="i18n.login.passwordTwice" icon="locked" size="large" class="input-left-icon"></Input>
        </Form-item>
        <Form-item>
          <Button type="primary" size="large" class="login-form-button no-circle" long @click="submitOnClick()">{{i18n.login.signup}}</Button>
          <Row class="login-form-links-group">
              <Col span="24" class="text-align-center"><router-link to="/welcome">{{i18n.backToMain}}</router-link></Col>
          </Row>
      </Form-item>
    </Form>
  </div>
</template>

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SignUp',
  data () {
    return {
      loginData: {
        user: '',
        email: '',
        password: '',
        passwordTwice: ''
      },
      validatePassword: (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.i18n.login.validations.fieldCannotBeEmpty))
        } else {
          if (this.loginData.passwordTwice !== '') {
            this.$refs.loginData.validateField('passwordTwice')
          }
          callback()
        }
      },
      validatePasswordTwice: (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.i18n.login.validations.fieldCannotBeEmpty))
        } else if (value !== this.loginData.password) {
          callback(new Error(this.i18n.login.validations.passwordsNotEqual))
        } else {
          callback()
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'i18n'
    ]),
    loginDataRules: function () {
      return {
        email: [
          { required: true, message: this.i18n.login.validations.fieldCannotBeEmpty, trigger: 'blur' },
          { type: 'email', message: this.i18n.login.validations.fieldIsNotEmail, trigger: 'blur' }
        ],
        user: [
          { required: true, message: this.i18n.login.validations.fieldCannotBeEmpty, trigger: 'blur' }
        ],
        password: [
          { validator: this.validatePassword, trigger: 'blur' }
        ],
        passwordTwice: [
          { validator: this.validatePasswordTwice, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitOnClick () {
      this.$message(JSON.stringify(this.loginData, 2))

      this.$refs['loginData'].validate((valid) => {
        if (valid) {
          this.$Message.success('удача')
        } else {
          this.$Message.error('ошибка')
        }
      })
    }
  }
}
</script>

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
</style>

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// SignUp.vue?53dbed56